import React, {useState} from "react";
import { Button, Input, Row, Col } from "antd";
import { CountryDataEntity } from "./CountryDataEntity";
import toast from "react-hot-toast";
import { DIALOG_KEY } from "../../shared/utils/enum";
import { useCountryData, useUpdateCountryData } from "./useCountryData";
import IsLoading from "../../shared/components/IsLoading";
import ErrorPage from "../../shared/components/ErrorPage";

const CountryEditModal = ({record, handleClose, dialogRef, handleSetDialog}) => {
    const [rows, setRows] = useState(new CountryDataEntity(record));
    const { data: countryData, isLoading, error } = useCountryData();
    const { mutate: updateCountryData, isPending } = useUpdateCountryData();

    const handleSetRows = (e) => {
        const { name, value } = e.target;
        setRows(new CountryDataEntity({
            ...rows,
            [name]: value
        }));
    }

    const handleSetCountryInfo = async () => {
        if (rows.isInvalidate()) {
            return;
        }
        const existingRowIndex = countryData.findIndex((row) => row.countryCode === rows.countryCode);
        const updatedRows = [...countryData];
        if (existingRowIndex >= 0) {
            updatedRows[existingRowIndex] = rows.toJson();
        } else {
            updatedRows.push(rows.toJson());
        }
        await handleSave(updatedRows);
    }

    const handleSave = async (updateData) => {
        updateCountryData(updateData, {
            onSuccess: () => {
                handleSetDialog([{key: DIALOG_KEY.OPEN, value: false}, {key: DIALOG_KEY.CONFIRM_TEXT, value: ""}]);
                handleClose();
                toast.success('서버 정보가 성공적으로 저장되었습니다.');
            },
            onError: (error) => {
                toast.error(error.response.data.message || '서버 정보를 저장하는데 에러가 발생했습니다.');
            }
        })
    }

    const handleDelete = async (e) => {
        if (rows.isInvalidate()) {
            return;
        }
        e.preventDefault();
        const currentDialog = dialogRef.current;
        if (currentDialog.confirmText === 'DELETE') {
            await handleSave(countryData.filter((country) => country.countryCode !== rows.countryCode));
        } else {
            toast.error("잘못된 확인 문자입니다. DELETE 를 입력하세요.");
            handleSetDialog([{key: DIALOG_KEY.CONFIRM_TEXT, value: ''}]);
        }
    }

    if (isLoading) return <IsLoading />;
    if (error) return <ErrorPage error={error} />;
    return (
        <div style={{ marginTop: 16 }}>
            <Row gutter={16} style={{ marginBottom: 16 }} align="middle">
                <Col span={12}>
                    <Input
                        name="countryCode"
                        value={rows.countryCode}
                        onChange={handleSetRows}
                        placeholder="국가 코드"
                        style={{ width: '100%', margin: '5px' }}
                    />
                </Col>
                <Col span={12}>
                    <Input
                        name="langCode"
                        value={rows.langCode}
                        onChange={handleSetRows}
                        placeholder="언어 코드"
                        style={{ width: '100%', margin: '5px' }}
                    />
                </Col>
            </Row>
            <Row gutter={16} style={{ marginBottom: 16 }} align="middle">
                <Col span={12}>
                    <Input
                        name="countryName"
                        value={rows.countryName}
                        onChange={handleSetRows}
                        placeholder="국가 이름"
                        style={{ width: '100%', margin: '5px' }}
                    />
                </Col>
                <Col span={12}>
                    <Input
                        name="languageName"
                        value={rows.languageName}
                        onChange={handleSetRows}
                        placeholder="언어 이름"
                        style={{ width: '100%', margin: '5px' }}
                    />
                </Col>
            </Row>
            <Row justify="end" gutter={8} style={{ marginTop: 24 }}>
                <Col>
                    <Button type="primary" loading={isPending} onClick={handleSetCountryInfo}>저장</Button>
                </Col>
                <Col>
                    <Button onClick={handleClose}>취소</Button>
                </Col>
                <Col>
                    {!rows.isNew && (
                        <Button danger loading={isPending} onClick={handleDelete}>삭제</Button>
                    )}
                </Col>
            </Row>
        </div>
    )
}

export default CountryEditModal;